import { SendMessage } from "@/graphql/mutations.js";
import { API, graphqlOperation } from "aws-amplify";
import { GetAllMessages } from "@/mixins/Chat/ListMessages.js";

export const SendMessages = {
  mixins: [GetAllMessages],
  data() {
    return {
      GetAllViolationsList: [],
      overlay: false,
      user_type: "",
      ChatsList: [],
    };
  },
  methods: {
    async SendMessagesMethod(ChatText) {
      try {
        let result = await API.graphql(
          graphqlOperation(SendMessage, {
            chat_id: this.$store.getters.get_chat_id,
            message_text: ChatText,
            message_type: "TEXT",
            messaged_by_id:
              this.$store.getters.get_current_user_details.user_id,
            message_sent_type: "NORMAL_MESSAGE",
            has_reply_message: false,
            no_of_replies: 0,
            replied_to_message_id: "DEFAULT",
            replied_for_message_type: "TEXT",
            replied_for_message_text: "DEFAULT",
            self_message: true,
          })
        );
        // this.ChatsList = JSON.parse(result.data.SendMessage).data[0];
        // this.$store.commit("SET_CHAT_LIST", this.ChatsList);
        this.CreateChat = "";
        this.GetAllMessagesMethod();
        this.GetAllChatsMethod();
        this.scrollToBottom();
        this.FireNotificationMethod();
      } catch (error) {
        console.log("Check error", error);
        // this.overlay = false;
      }
    },
  },
};
